export default __webpack_public_path__ + "static/media/achievements-icon.697d09b3.svg";